import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

const CONTASAPAGAR_URL = `${API_URL}/contasapagar/`;

export async function getContasAPagars(alias, page, token) {
    const ContasAPagarUrl = `${CONTASAPAGAR_URL}${alias}?page=${page}`;
    const headers = { 'authorization': token }

    console.log(ContasAPagarUrl);
    const response = await axios.get(ContasAPagarUrl, { headers });
    return response.data;
}

export async function getContasAPagar(id, token) {
    const ContasAPagarUrl = `${CONTASAPAGAR_URL}id/${id}`;
    const headers = { 'authorization': token }

    console.log(ContasAPagarUrl);
    const response = await axios.get(ContasAPagarUrl, { headers });
    return response.data;
}

export async function getAllContasAPagars(token) {
    const headers = { 'authorization': token }
    const response = await axios.get(`${CONTASAPAGAR_URL}all`, { headers });
    return response.data;
}

export async function getActiveContasAPagars(token) {
    const headers = { 'authorization': token }
    const response = await axios.get(`${CONTASAPAGAR_URL}active`, { headers });
    return response.data;
}

export async function saveContasAPagar(id, newContasAPagar, token) {
    const headers = { 'authorization': token };
    let response;
    if (id)
        response = await axios.patch(`${CONTASAPAGAR_URL}${id}`, newContasAPagar, { headers });
    else
        response = await axios.post(CONTASAPAGAR_URL, newContasAPagar, { headers });
    return response.data;
}
